import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class IconService {

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
  ) {
  }

  setCustomIcons() {
    const icons: string[] = [
      'network',
      'payment',
      'processes',
    ];
    for (const icon of icons) {
      this.matIconRegistry.addSvgIcon(
        `psc-${ icon }`,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/svg/icons/${ icon }.svg`),
      );
    }
  }
}
